import React from "react";
import styled from "styled-components";
import Button from "app/components/Button";
import PropTypes from "prop-types";
import Loader from "app/components/Loader";

const Span = styled.span`
  opacity: 1;

  ${props =>
    props.loading &&
    `
    opacity: 0
  `}
`;

const LoaderWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
`;

const ButtonWithLoader = ({ children, disabled, loading, ...rest }) => (
  <Button p={0} {...rest} disabled={disabled || loading}>
    <Span loading={loading}>{children}</Span>
    {loading && (
      <LoaderWrapper>
        <Loader light width="24" />
      </LoaderWrapper>
    )}
  </Button>
);

ButtonWithLoader.defaultProps = {
  children: <span>Save</span>,
  className: null,
  disabled: false,
  loading: false,
};

ButtonWithLoader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default ButtonWithLoader;
